import axios from 'axios';
import { history } from '../../../History';
import config from '../../../config/api';
import { message } from 'antd';
import { togglePreloader } from '../App/AppActions';
import { resetAuthReducer } from '../Auth/AuthActions';

export const setIsIcSelect = (data) => ({
  type: 'SET_IS_IC_SELECT',
  data
})

export const setIsClient = (data) => ({
  type: 'SET_IS_CLIENT',
  data
})

export const setPrimaryTabsList = (data) => ({
  type: 'SET_PRIMARY_TABS_LIST',
  data
})

export const setAccessCategories = (data) => ({
  type: 'SET_ACCESS_CATEGORIES_LIST',
  data
})

export const setAddingClientStatus = (data) => ({
  type: 'SET_ADDING_CLIENT_STATUS',
  data
})

export const setIcBoxUserList = (data) => ({
  type: 'SET_IC_BOX_USER_LIST',
  data
})

export const setIcBoxUserSearch = (data) => ({
  type: 'SET_IC_BOX_USER_SEARCH',
  data
})

export const setIcBoxUserSearchText = (data) => ({
  type: 'SET_IC_BOX_USER_SEARCH_TEXT',
  data
})

export const setIcBoxUserToUpdate = (data) => ({
  type: 'SET_IC_BOX_USER_TO_UPDATE',
  data
})

export const getPrimaryTabsList = () => {
  return function (dispatch) {
    dispatch(togglePreloader(true));
    const token = JSON.parse(sessionStorage.getItem('user')).data.token;
    const email = JSON.parse(sessionStorage.getItem('user')).data.email;
    const role = JSON.parse(sessionStorage.getItem('user')).data.role;
    const form_data = {
      auth: { key: token },
      cmd: 'tabs:list',
      authUser: {
        role, email
      }
    };
    axios({
      method: 'post',
      url: `${config.api_url}`,
      data: form_data
    })
      .then(response => {
        if (response.data.reply.code === 200) {
          dispatch(togglePreloader(false));
          dispatch(setPrimaryTabsList(response.data.reply.message));
        }
        else if (response.data.reply.code === 401 || response.data.reply.code === 403) {
          message.error('You have been logged out! Please login to continue');
          dispatch(togglePreloader(false));
          dispatch(resetAuthReducer());
          history.push('/');
        }
      })
      .catch((error) => {
        dispatch(togglePreloader(false));
        console.log(error);
      })
  }
}

export const getCategoriesList = () => {
  return function (dispatch) {
    dispatch(togglePreloader(true));
    const token = JSON.parse(sessionStorage.getItem('user')).data.token;
    const email = JSON.parse(sessionStorage.getItem('user')).data.email;
    const role = JSON.parse(sessionStorage.getItem('user')).data.role;
    const form_data = {
      auth: { key: token },
      authUser: {
        role, email
      }
    };
    axios({
      method: 'get',
      url: `${config.url}api/categories`,
      data: form_data
    })
      .then(response => {
        console.log(response, "CATE RESPONSE")
        if (response.status === 200) {
          dispatch(togglePreloader(false));
          dispatch(setAccessCategories(response.data));
        }
        else if (response.status === 401 || response.atatus === 403) {
          message.error('You have been logged out! Please login to continue');
          dispatch(togglePreloader(false));
          dispatch(resetAuthReducer());
          history.push('/');
        }
      })
      .catch((error) => {
        dispatch(togglePreloader(false));
        console.log(error);
      })
  }
}

export const addClient = (data, from) => {
  return function (dispatch) {
    dispatch(setAddingClientStatus(true));
    const token = JSON.parse(sessionStorage.getItem('user')).data.token;
    const email = JSON.parse(sessionStorage.getItem('user')).data.email;
    const role = JSON.parse(sessionStorage.getItem('user')).data.role;

    if (from === 'update') {
      data.cmd = 'icBoxUser:update';
      delete data['password'];
    }
    else {
      data.cmd = 'icBoxUser:add';
    }

    data.auth = { key: token };
    data.authUser = { role, email }
    console.log("DATE", data)
    // history.push("/home/client/add")
    axios({
      method: 'post',
      url: `${config.api_url}`,
      data: data
    })
      .then(response => {
        if (response.data.reply.code === 200) {
          message.success(response.data.reply.message);
          dispatch(setAddingClientStatus(false));
        }
        else if (response.data.reply.code === 400) {
          message.error(response.data.reply.message);
          dispatch(setAddingClientStatus(false));
        }
        else if (response.data.reply.code === 401 || response.data.reply.code === 403) {
          message.error('You have been logged out! Please login to continue');
          dispatch(setAddingClientStatus(false));
          dispatch(resetAuthReducer());
          history.push('/');
        }
      })
      .catch((error) => {
        dispatch(setAddingClientStatus(false));
      })
  }
}

export const getIcBoxUserList = () => {
  return function (dispatch) {
    dispatch(togglePreloader(true));
    // console.log(JSON.parse(sessionStorage.getItem('user')).data.token)
    const token = JSON.parse(sessionStorage.getItem('user')).data.token;
    const email = JSON.parse(sessionStorage.getItem('user')).data.email;
    const role = JSON.parse(sessionStorage.getItem('user')).data.role;
    const form_data = {
      auth: { key: token },
      cmd: 'icBoxUser:list',
      authUser: {
        role, email
      }
    };
    axios({
      method: 'post',
      url: `${config.api_url}`,
      data: form_data
    })
      .then(response => {
        if (response.data.reply.code === 200) {
          dispatch(togglePreloader(false));
          dispatch(setIcBoxUserList(response.data.reply.message));
        }
        else if (response.data.reply.code === 401 || response.data.reply.code === 403) {
          history.push('/');
          dispatch(togglePreloader(false));
          dispatch(resetAuthReducer());
        }
      })
      .catch((error) => {
        dispatch(togglePreloader(false));
      })
  }
}

export const getClient = (data) => {
  return function (dispatch) {
    const token = JSON.parse(sessionStorage.getItem('user')).data.token;
    const email = JSON.parse(sessionStorage.getItem('user')).data.email;
    const role = JSON.parse(sessionStorage.getItem('user')).data.role;
    dispatch(togglePreloader(true));
    const form_data = {
      cmd: 'icBoxUser:get',
      auth: { key: token },
      username: data,
      authUser: {
        role, email
      }
    }
    axios({
      method: 'post',
      url: `${config.api_url}`,
      data: form_data
    })
      .then(response => {
        if (response.data.reply.code === 200) {
          dispatch(togglePreloader(false));
          dispatch(setIcBoxUserToUpdate(response.data.reply.message));
        }
        else if (response.data.reply.code === 401 || response.data.reply.code === 403) {
          dispatch(togglePreloader(false));
          dispatch(resetAuthReducer());
          history.push('/');
        }
      })
      .catch((error) => {
        dispatch(togglePreloader(false));
      })
  }
}


// WEBPACK FOOTER //
// ./src/redux/actions/Client/ClientActions.js